export enum ClickCtaUxSource {
  Top = 'top_button',
  TopRightHeader = 'top_right_header_button',
  Bottom = 'bottom_button',
  PreviewScreen = 'preview_screen',
  ToolsVideoTrimmerEditor = 'tools_video_trimmer_editor',
  WorkflowCard = 'workflow_card',
  ClickSupportIcon = 'click_support_icon',
}

export enum ClickCtaType {
  ClickSignup = 'click_signup',
  ClickLogin = 'click_login',
  ClickDownload = 'click_download',
  ClickSupport = 'click_support',
}

export interface ClickCtaEventProperties {
  ux_source: ClickCtaUxSource;
  type: ClickCtaType;
  feature_utm: string;
  product: AnalyticsProductType;
}

export interface ProjectDetails {
  project_id: string;
  template_id: string;
  template_name: string;
  template_type: string;
  dimension: string;
}

export interface ClickExportEventProperties {
  ux_source: string;
  editor_mode: string;
  project_details: ProjectDetails;
  resolution: number;
}

export interface ClickCtaAnalytics {
  event_name: 'click_cta';
  event_properties: ClickCtaEventProperties;
  user_properties?: any;
}

export interface ClickExportAnalytics {
  event_name: 'click_export';
  event_properties: ClickExportEventProperties;
  user_properties?: any;
}

export interface RequestEditorEventProperties {
  ux_source: string;
  search_term: string;
  filter_state: string;
  feature_utm: string;
  project_details: ProjectDetails;
}

export interface RequestEditorAnalytics {
  event_name: 'request_editor';
  event_properties: RequestEditorEventProperties;
  user_properties?: any;
}

export enum AnalyticsProductType {
  AI = 'AI',
  STUDIO = 'studio',
}
